import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import Clear from '@mui/icons-material/Clear'
import FilterList from '@mui/icons-material/FilterList'
import { Grid, IconButton, InputAdornment } from '@mui/material'
import { selectInvoicesFilter } from 'lib/helpers/selectors'
import { useAppSelector } from 'store/hooks'
import { setFilterValue } from 'actions/invoices'
import { useCFDIsContainerContext } from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import Button from 'components/Shared/Button/Button'
import IOCustomForm from 'components/FormComponents/IOComponents/IOCustomForm/IOCustomForm'
import TextField from 'components/FormComponents/IOComponents/TextField/TextField'
import './styles.scss'

const CFDIsFilters = () => {
  const {
    CFDIsPaginatedData,
    isCFDIsTab,
    tableHeadersAnchor,
    onResetFilters,
    updateState,
  } = useCFDIsContainerContext()

  const { isLoading } = CFDIsPaginatedData

  const dispatch = useDispatch()

  const intl = useIntl()

  const filters = useAppSelector(selectInvoicesFilter)

  return (
    <IOCustomForm
      id="CFDIsFilters"
      onSubmit={async form => {
        dispatch(setFilterValue('search', form.search))
      }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          <TextField
            name="search"
            label="Buscar"
            placeholder={
              isCFDIsTab
                ? 'Busca por folio, serie, UUID o razón social'
                : 'Busca por razón social'
            }
            value={filters?.search}
            onValue={(v: string) => !v && dispatch(setFilterValue('search', v))}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    type="reset"
                    size="small"
                    id="clearSearchBtn"
                    onClick={() => dispatch(setFilterValue('search', ''))}>
                    <Clear />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={8} className="filter-actions">
          <div className="elements left">
            <Button
              id="searchBtn"
              type="submit"
              variant="outlined"
              color="secondary"
              disabled={filters?.advance || isLoading}>
              {intl.formatMessage({ id: 'button.search' })}
            </Button>
            <Button
              id="toggleAdvanceSearchBtn"
              variant="hover"
              color={filters.advance ? 'primary' : 'secondary'}
              startIcon={filters.advance ? <Clear /> : <FilterList />}
              onClick={() => {
                onResetFilters()
                dispatch(setFilterValue('advance', !filters.advance))
              }}>
              {intl.formatMessage({ id: 'button.advance_search' })}
            </Button>
          </div>
          <div className="elements">
            <Button
              id="toggleFiltersBtn"
              variant="hover"
              color={Boolean(tableHeadersAnchor) ? 'primary' : 'secondary'}
              startIcon={
                Boolean(tableHeadersAnchor) ? <Clear /> : <FilterList />
              }
              onClick={e =>
                updateState(draft => {
                  draft.tableHeadersAnchor = e.currentTarget
                })
              }>
              {intl.formatMessage({ id: 'button.filter_columns' })}
            </Button>
          </div>
        </Grid>
      </Grid>
    </IOCustomForm>
  )
}

export default CFDIsFilters
